export class FieldEntry {
	id: number;
	formFieldId: number;
	fieldOrder: number;
	fieldTypeDescription: string;
	displayValue: string;
	value: string;
}

export interface FieldType {
	id: number;
	displayValue: string;
	formTypeDescription: string;
}

export interface ListValue {
	id: number;
	listValue: string;
	formFieldId: number;
}

export interface Field {
	id: number;
	formId: number;
	defaultFieldOrder: number;
	fieldType: FieldType;
	listValues: ListValue[];
}

export interface WorkforceForm {
	id: number;
	formName: string;
	requiredToClear: boolean;
	requiredInWorkforce: boolean;
	requiredInMobiletech: boolean;
	fields: Field[];
	availabeTicketCodes: number[];
}

export class WorkforceFormEntry {
	id: number;
	apptId: number;
	ticketId: number;
	formName: string;
	requiredToClear: boolean;
	requiredInWorkforce: boolean;
	requiredInMobiletech: boolean;
	availabeTicketCodes: number[] = [];
	entries: FieldEntry[] = [];
}
